import React from 'react';
import { HealthDataFilterFormValues } from './Filter/HealthDataFilterForm';
import SideFilter from '../../../Components/Filter/SideFilter';
// @ts-ignore
import styles from './HealthData.module.scss';

interface HealthDataFilter {
	onSubmit: (values: HealthDataFilterFormValues) => void;
}

interface HealthDataProps {
	FilterComponent?: React.FC<HealthDataFilter>;
	children: React.ReactNode;
	setFilter?: (values: HealthDataFilterFormValues) => void;
}

const HealthDataWrapper: React.FC<HealthDataProps> = ({
	FilterComponent,
	children,
	setFilter,
}) => {
	return (
		<>
			<div className={styles.wrapper}>
				{FilterComponent && setFilter && (
					<div className={styles.filterWrapper}>
						<SideFilter className={styles.filter}>
							<FilterComponent
								onSubmit={(values: HealthDataFilterFormValues) =>
									setFilter(values)
								}
							/>
						</SideFilter>
					</div>
				)}
				<div className={'flex-grow-1 position-relative'}>
					<div className={styles.chartsWrapper}>{children}</div>
				</div>
			</div>
		</>
	);
};

export default HealthDataWrapper;
